import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { AbstractDynamicComponent } from '@components/abstracts';
import { OptionCardComponent } from '@shared/components/option-card';
import { SvgComponent } from '@shared/components/svg';
import { EmptyData } from '@shared/models';
import { GenerateRangePipe } from '@shared/pipe';
import { ElasticSearchService } from '@shared/services/elastic-search';

@Component({
  selector: 'app-listing-categories-facades',
  imports: [SvgComponent, GenerateRangePipe, OptionCardComponent, RouterLink],
  templateUrl: './listing-categories-facades.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListingCategoriesFacadesComponent extends AbstractDynamicComponent<EmptyData> {
  protected readonly frontsCategories = toSignal(inject(ElasticSearchService).getFrontsCategories());
}
